import { css } from "@emotion/css";
import type { DataTableColumn } from "@octopusdeploy/design-system-components";
import { InlineMessage, SimpleDataTable } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { isValidPageInstanceSummary, usePageInstanceSummary } from "@octopusdeploy/portal-routes";
import { sortBy } from "lodash";
import type { RnDTeam } from "~/RnDTeam";
import { allPagesFlattened } from "~/routing/pageRegistrations/allPageRegistrations";
export function SiteMapTab() {
    const page = usePageInstanceSummary();
    const isValidPage = isValidPageInstanceSummary(page);
    const pages = allPagesFlattened.map((p) => createSiteMapRow(p.route.getDebugString(), p.pageId, p.pageArea.mainArea, p.owner));
    const orderedPages = sortBy(pages, [(r) => r.pageArea, (r) => r.pageId]);
    const columns: DataTableColumn<SiteMapRow>[] = [
        { title: "Area", render: (p) => p.pageArea, columnSize: "small" },
        { title: "Page Id", render: (p) => p.pageId, columnSize: "small" },
        { title: "Owner", render: (p) => p.owner, columnSize: "small" },
        { title: "Route", render: (p) => p.templatedRoute },
    ];
    return (<div>
            {page && page.Id && isValidPage && (<div className={styles.currentPageContainer}>
                    <InlineMessage type="information" description={`Currently viewing the ${page.Id} owned by ${page.owner}`}/>
                </div>)}

            <SimpleDataTable columns={columns} data={orderedPages} getRowKey={(r) => r.templatedRoute}/>
        </div>);
}
const styles = {
    currentPageContainer: css({
        padding: space[16],
    }),
};
function createSiteMapRow(routeDebugString: string, pageId: string, pageArea: string, owner: RnDTeam): SiteMapRow {
    return {
        pageArea,
        pageId,
        owner,
        templatedRoute: routeDebugString,
    };
}
interface SiteMapRow {
    pageArea: string;
    pageId: string;
    owner: RnDTeam;
    templatedRoute: string;
}
